// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ke-2";
export var chatLink = "_ke-0";
export var chatText = "_ke-1";